import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{ borderTop: "1px solid var(--border)", marginTop: 80, padding: "40px 24px 28px", background: "var(--bg-2)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", flexDirection: "column", gap: 24 }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 24, justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ maxWidth: 340 }}>
            <div className="serif" style={{ fontSize: 22, color: "var(--gold)", marginBottom: 8 }}>Obituary Relief</div>
            <div className="muted" style={{ fontSize: 13, lineHeight: 1.6 }}>
              An obituary builder for families and funeral professionals — composed with grace and dignity.
            </div>
          </div>
          <div style={{ display: "flex", gap: 28, flexWrap: "wrap" }}>
            <div>
              <div className="label-dark" style={{ marginBottom: 12 }}>Legal</div>
              <Link to="/privacy" data-testid="footer-privacy" className="link-gold" style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Privacy</Link>
              <Link to="/terms" data-testid="footer-terms" className="link-gold" style={{ display: "block", fontSize: 14 }}>Terms</Link>
            </div>
            <div>
              <div className="label-dark" style={{ marginBottom: 12 }}>Help</div>
              <Link to="/contact" data-testid="footer-contact" className="link-gold" style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Contact</Link>
              <a href="mailto:customerservice@obituaryrelief.com" className="link-gold" style={{ display: "block", fontSize: 14 }}>customerservice@obituaryrelief.com</a>
            </div>
          </div>
        </div>
        <div className="gold-line" style={{ margin: "8px 0", width: "100%" }} />
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
          <div className="muted" style={{ fontSize: 12 }}>© {new Date().getFullYear()} Obituary Relief. All rights reserved.</div>
          <div className="muted" style={{ fontSize: 12, fontStyle: "italic" }}>— Composed with Obituary Relief —</div>
        </div>
      </div>
    </footer>
  );
}
